









import Vue from 'vue';
import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from '@/components/Navbar.vue';

export default Vue.extend({
  components: {
    Navbar,
  },
  name: 'App',
});
